export const getRiskToleranceRanges = (
  questionnaireLength: number,
  colors = [] as any
) => {
  return questionnaireLength === 10
    ? [
        {
          label: 'Very Low',
          color: colors[0],
          rangeStart: 0,
          rangeEnd: 34
        },
        {
          label: 'Low',
          color: colors[1],
          rangeStart: 35,
          rangeEnd: 44
        },
        {
          label: 'Average',
          color: colors[2],
          rangeStart: 45,
          rangeEnd: 54
        },
        {
          label: 'High',
          color: colors[3],
          rangeStart: 55,
          rangeEnd: 64
        },
        {
          label: 'Very High',
          color: colors[4],
          rangeStart: 65,
          rangeEnd: 100
        }
      ]
    : [
        {
          label: 'Lowest',
          color: colors[0],
          rangeStart: 0,
          rangeEnd: 24
        },
        {
          label: 'Very Low',
          color: colors[1],
          rangeStart: 25,
          rangeEnd: 34
        },
        {
          label: 'Low',
          color: colors[2],
          rangeStart: 35,
          rangeEnd: 44
        },
        {
          label: 'Average',
          color: colors[3],
          rangeStart: 45,
          rangeEnd: 54
        },
        {
          label: 'High',
          color: colors[4],
          rangeStart: 55,
          rangeEnd: 64
        },
        {
          label: 'Very High',
          color: colors[5],
          rangeStart: 65,
          rangeEnd: 74
        },
        {
          label: 'Highest',
          color: colors[6],
          rangeStart: 75,
          rangeEnd: 100
        }
      ];
};

export const getComfortRanges = (colors = [] as any) => {
  return [
    {
      value: 0,
      label: 'Too Little Risk',
      color: colors[0]
    },
    {
      value: 25,
      label: 'Marginal',
      key: 'Marginal Lower',
      color: colors[1]
    },
    {
      value: 50,
      label: 'OK Risk',
      color: colors[2]
    },
    {
      value: 75,
      label: 'Marginal',
      key: 'Marginal Upper',
      color: colors[1]
    },
    {
      value: 100,
      label: 'Too Much Risk',
      color: colors[0]
    }
  ];
};
